module.exports = __webpack_public_path__ + "img/image08_sp.31762e15.jpg";